var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoResumo01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2476",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1396",
    d: "M28.8,10.7c0.4,0,0.7-0.3,0.7-0.7v0V2.5c0-1.1-0.9-2.1-2.1-2.1H2.5c-1.1,0-2.1,0.9-2.1,2.1v31 c0,1.1,0.9,2.1,2.1,2.1h24.9c1.1,0,2.1-0.9,2.1-2.1v-5c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.7,0.3-0.7,0.7c0,0,0,0,0,0.1v5 c0,0.4-0.3,0.7-0.7,0.7h0H2.5c-0.4,0-0.7-0.3-0.7-0.7l0,0v-31c0-0.4,0.3-0.7,0.7-0.7l0,0h24.9c0.4,0,0.7,0.3,0.7,0.7V10 C28.1,10.3,28.4,10.7,28.8,10.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2479",
    transform: "translate(4.688 2.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1397",
    d: "M10.3,2.1C6.8,2.1,4,4.9,4,8.3c0,1.7,0.7,3.4,2,4.6C6,13,6,13,6,13c2.4,2.2,6.1,2.2,8.5,0 c0,0,0.1,0,0.1-0.1c2.5-2.4,2.6-6.4,0.3-8.9C13.7,2.8,12,2.1,10.3,2.1z M10.3,13.3c-1.1,0-2.1-0.4-3-1c0.9-1.6,3-2.2,4.7-1.3 c0.5,0.3,1,0.8,1.3,1.3C12.4,12.9,11.4,13.3,10.3,13.3z M9.2,8.1V7.6c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1v0.4 c0,0.6-0.5,1.1-1.1,1.1C9.7,9.2,9.2,8.7,9.2,8.1z M14.3,11.3c-0.5-0.7-1.2-1.3-2-1.7c0.3-0.4,0.5-1,0.5-1.5V7.6 c0-1.4-1.1-2.5-2.5-2.5S7.8,6.3,7.8,7.6v0.4c0,0.5,0.2,1.1,0.5,1.5c-0.8,0.4-1.5,0.9-2,1.7C4.7,9.1,5.2,6,7.4,4.4 c2.2-1.6,5.3-1.2,6.9,1C15.6,7.2,15.6,9.5,14.3,11.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2481",
    transform: "translate(7.891 17.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1398",
    d: "M10.8,13.4H7.1c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.6,0.7,0.7h3.7c0.4,0,0.7-0.3,0.7-0.7 C11.4,13.7,11.2,13.4,10.8,13.4L10.8,13.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2483",
    transform: "translate(4.453 14.924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2482"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1399",
    d: "M14.2,11.7H4.5c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.6,0.7,0.7h9.7c0.4,0,0.7-0.3,0.7-0.7 C14.9,12,14.6,11.7,14.2,11.7L14.2,11.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2485",
    transform: "translate(4.453 12.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1400",
    d: "M14.2,10.1H4.5c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7c0,0,0,0,0.1,0h9.7 c0.4,0,0.7-0.3,0.7-0.7C15,10.4,14.7,10.1,14.2,10.1C14.3,10.1,14.3,10.1,14.2,10.1L14.2,10.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2487",
    transform: "translate(2.783 10.549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2486"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1401",
    d: "M3.7,8.6c-0.3-0.3-0.7-0.3-1,0c-0.3,0.3-0.3,0.7,0,1c0.3,0.3,0.7,0.3,1,0c0.1-0.1,0.2-0.3,0.2-0.5 C3.9,8.9,3.9,8.7,3.7,8.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2489",
    transform: "translate(2.783 12.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1402",
    d: "M3.7,10.3c-0.3-0.3-0.7-0.3-1,0c-0.3,0.3-0.3,0.7,0,1c0.3,0.3,0.7,0.3,1,0c0.1-0.1,0.2-0.3,0.2-0.5 C3.9,10.6,3.9,10.4,3.7,10.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2491",
    transform: "translate(2.783 14.924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1403",
    d: "M3.7,11.9c-0.3-0.3-0.7-0.3-1,0c-0.3,0.3-0.3,0.7,0,1c0.3,0.3,0.7,0.3,1,0c0.1-0.1,0.2-0.3,0.2-0.5 C3.9,12.2,3.9,12,3.7,11.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2493",
    transform: "translate(4.453 10.549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1404",
    d: "M14.2,8.4H4.5c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7c0,0,0,0,0.1,0h9.7c0.4,0,0.7-0.3,0.7-0.7 C15,8.8,14.7,8.4,14.2,8.4C14.3,8.4,14.3,8.4,14.2,8.4L14.2,8.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2495",
    transform: "translate(11.625 4.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1405",
    d: "M22.5,4.5c-1.4-0.8-3.1-0.3-3.9,1.1L9.9,20.5c0,0.1-0.1,0.2-0.1,0.3l-0.6,5.4c0,0.4,0.2,0.7,0.6,0.8 c0.2,0,0.3,0,0.5-0.1l4.4-3.2c0.1-0.1,0.1-0.1,0.2-0.2l8.6-14.9C24.3,7.1,23.8,5.3,22.5,4.5z M10.8,24.8l0.3-2.8l2,1.1L10.8,24.8 z M14.1,22.1l-2.6-1.5l6.9-12l2.6,1.5L14.1,22.1z M22.3,7.8l-0.7,1.2l-2.6-1.5l0.7-1.2c0.4-0.7,1.3-1,2.1-0.6 C22.5,6.1,22.8,7.1,22.3,7.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoResumo01);
export default __webpack_public_path__ + "static/media/ico-resumo-01.0e2b7d86f699be3ca23f00fb8f5ee320.svg";
export { ForwardRef as ReactComponent };